const hoarse =[

    {label:"Description:",
    controlType:"checkbox group",
    options:["strained", "husky", "breathy", "pitch change" ],
    },

    {label:"Pain:",
    controlType:"radio button",
    options:["Throat pain", "No throat pain"]
    },

    {label:"Any other features",
    controlType:"text area",
    options:[]
    },

    {label:"Frequency:",
    controlType:"radio button",
    options:["Occasonally ", "Frequently ","Continuously "]
    },


    {label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }

]

export default hoarse